// extracted by mini-css-extract-plugin
module.exports = {"Window":"RematchWindow_Window__IOCJ6"};